module.exports = function() {
  return new Worker(__webpack_public_path__ + "7e9328ba7abae98d5582.worker.js");
};